import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BurnHero"] */ "/app/src/features/burn/BurnHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNav"] */ "/app/src/features/landing/LandingNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TakeoverWordmark"] */ "/app/src/features/lobby/ui/TakeoverIcon.tsx");
